// extracted by mini-css-extract-plugin
export default {"discount-banner":"DiscountBanner_discount-banner__MGePy","detail-btn":"DiscountBanner_detail-btn__0TO4G"};